import { Box } from "@chakra-ui/react";
import React from "react";
import "./header-grey-bg.css";

export const HeaderBackground: React.FC = () => (
  <Box width="100%" className="headerGrey" />
);
